const activationCodeRouter = [
  {
    path: '/activation-code',
    name: 'activation-code',
    component: () => import('@/views/activation-code/activation-code-course/index.vue'),
    meta: {
      title: '课程激活',
    }
  },
  {
    path: '/activation-code-success',
    name: 'activation-code-success',
    component: () => import('@/views/activation-code/activation-code-course-success/index.vue'),
    meta: {
      title: '激活成功',
    }
  },
];
export default activationCodeRouter;